import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { fetchCaptableAction } from '../../../../modules/actions';
import StatutoryBooks from '../components';

const mapStateToProps = state => ({
  literalsCommon: state.i18n.literals.common,
  literals: state.i18n.literals.captable,
  captable: state.captable,
  startup: state.global.startup,
});

function mapDispatchToProps(dispatch) {
  return {
    fetchCaptable: bindActionCreators(fetchCaptableAction, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(StatutoryBooks);
